import UploadFileItem from '../UploadFileItem';

/**
 * Handles adding files to the upload list.
 * Deduplicates by fileName+size — same file added twice is ignored.
 * Creates UploadFileItem instances — previewUrl is set in constructor for image files.
 */
export default class OnFilesAddedHandler {

    /**
     * @param {object} state - shared upload state from UploadAttachmentHandler
     */
    constructor(state) {
        this._state = state;
    }

    /**
     * Merges incoming files into state.files, skipping duplicates.
     * Auto-selects the newly added file when exactly one file is added.
     * @param {{ fileList: FileList, defaultProvider: string }} data
     */
    handle({ fileList, defaultProvider }) {
        const incoming = Array.from(fileList);
        const existing = new Set(this._state.files.map((item) => item.getKey()));

        const newItems = incoming
            .filter((f) => {
                const key = `${f.name}_${Math.round(f.size / 1024)}`;
                return !existing.has(key);
            })
            .map((f) => new UploadFileItem(f, defaultProvider));

        if (!newItems.length) return;

        this._state.files = [...this._state.files, ...newItems];

        // Auto-select the single newly added file for immediate description/provider edit
        if (newItems.length === 1) {
            this._state.selectedIndex = this._state.files.length - 1;
        }
    }
}
